import './confettiful.css'

const CONFETTI_COLORS = ['#fce18a', '#ff726d', '#b48def', '#f4306d']
const CONFETTI_ANIMATIONS = ['slow', 'medium', 'fast'] as const
const FADE_OUT_MS = 400

export class Confettiful {
  private readonly el: HTMLElement
  private containerEl: HTMLDivElement | null = null
  private confettiInterval: ReturnType<typeof setInterval> | null = null
  private removeTimeouts = new Set<ReturnType<typeof setTimeout>>()
  private destroyed = false

  constructor(el: HTMLElement) {
    this.el = el
    this.setupElements()
    this.start()
  }

  private setupElements() {
    const containerEl = document.createElement('div')
    containerEl.className = 'guided-intro-confetti-container'
    this.el.appendChild(containerEl)
    this.containerEl = containerEl
  }

  private start() {
    if (!this.containerEl) return

    this.confettiInterval = setInterval(() => {
      if (!this.containerEl || this.destroyed) return

      const confettiEl = document.createElement('div')
      const confettiSize = `${Math.floor(Math.random() * 3) + 7}px`
      const confettiBackground =
        CONFETTI_COLORS[Math.floor(Math.random() * CONFETTI_COLORS.length)] ?? CONFETTI_COLORS[0]
      const confettiLeft = `${Math.floor(Math.random() * this.el.offsetWidth * 0.65)}px`
      const confettiAnimation =
        CONFETTI_ANIMATIONS[Math.floor(Math.random() * CONFETTI_ANIMATIONS.length)] ??
        CONFETTI_ANIMATIONS[0]

      confettiEl.className = `guided-intro-confetti guided-intro-confetti--animation-${confettiAnimation}`
      confettiEl.style.left = confettiLeft
      confettiEl.style.width = confettiSize
      confettiEl.style.height = confettiSize
      confettiEl.style.backgroundColor = confettiBackground

      const removeTimeout = setTimeout(() => {
        confettiEl.remove()
        this.removeTimeouts.delete(removeTimeout)
      }, 3000)
      this.removeTimeouts.add(removeTimeout)

      this.containerEl.appendChild(confettiEl)
    }, 25)
  }

  fadeOut(onComplete?: () => void) {
    if (this.destroyed) {
      onComplete?.()
      return
    }

    if (this.confettiInterval) {
      clearInterval(this.confettiInterval)
      this.confettiInterval = null
    }

    if (this.containerEl) {
      this.containerEl.style.opacity = '0'
    }

    setTimeout(() => {
      this.destroy()
      onComplete?.()
    }, FADE_OUT_MS)
  }

  destroy() {
    if (this.destroyed) return
    this.destroyed = true

    if (this.confettiInterval) {
      clearInterval(this.confettiInterval)
      this.confettiInterval = null
    }

    for (const timeout of this.removeTimeouts) {
      clearTimeout(timeout)
    }
    this.removeTimeouts.clear()

    this.containerEl?.remove()
    this.containerEl = null
  }
}
